import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DirectiveModule } from '../../shared/directives/directive.module';
import { InstitutionalRoutingModule } from './institutional-routing.module';
import { FormsService } from './services/forms.service';
import { LocalizationService } from './services/localization.service';

@NgModule({
	declarations: [],
	imports: [CommonModule, InstitutionalRoutingModule, DirectiveModule],
	providers: [FormsService, LocalizationService],
})
export class InstitutionalModule {}
